module.exports = __webpack_public_path__ + "7273908446673a3494c2435443c6279a.svg";